import Link from "next/link"
import React, { PureComponent } from "react"
import ReactCSSTransitionGroup from "react-addons-css-transition-group"
import { Mutation } from "react-apollo"
import ReactMarkdown from "react-markdown"

import customRendererLink from "../../utils/custom-link-renderer"
import convertProfilePicUrl from "../../utils/convert-profile-pic-url"
import Cta from "../cta/cta"
import Tag from "../tag/tag"

import gql from "graphql-tag"
import { LOCAL_TOGGLE_IDEAS } from "../../apollo-state/graphql/mutations"
import { needsLine } from "../../data/skill-phrases"
import "./ideasCards.scss"

const UPDATE_IDEAS_LIKES = gql`
  mutation TOGGLE_LIKE_IDEA($ideaId: ID!) {
    toggleLikeIdea(ideaId: $ideaId) {
      id
      __typename
      totalLikes
      likes {
        id
        user {
          id
        }
      }
    }
  }
`

export const SAVE_IDEA = gql`
  mutation TOGGLE_LIKE_IDEA($ideaId: ID!) {
    toggleSaveIdea(ideaId: $ideaId) {
      id
      totalLikes
      saves {
        id
        user {
          id
        }
      }
    }
  }
`
class IdeasCards extends PureComponent {
  constructor() {
    super()
  }

  render() {
    const { data, popupData, me } = this.props
    // what the founder is looking for, instead of like counts (most are 0)
    const needs = needsLine(data?.createdBy?.wantsSkills)
    return (
      <ReactCSSTransitionGroup
        transitionName="overlay"
        transitionAppear={true}
        component={React.Fragment}
        transitionAppearTimeout={500}
        transitionEnter={false}
        transitionLeave={false}
      >
        <article className="idea-card-horizontal">
          <div className="idea-card__content">
            {/* Header with title and creator info */}
            <div className="idea-card__header">
              <div className="idea-card__title-section">
                <div className="idea-card__icon">
                  <img
                    src={convertProfilePicUrl(data?.createdBy?.profilePic, 40, 40)}
                    alt="User"
                    width="24"
                    height="24"
                    style={{ borderRadius: "50%", objectFit: "cover" }}
                  />
                </div>
                <div className="idea-card__title-content">
                  <Link href="/ideas/[id]" as={`/ideas/${data.id}`}>
                    <a className="idea-card__title">{data.title}</a>
                  </Link>
                  <div className="idea-card__meta">
                    <span className="idea-card__creator">
                      Created by {data?.createdBy?.firstName || "Anonymous"}
                    </span>
                  </div>
                </div>
              </div>

              {/* Tags moved out of the title section to avoid flex overflow issues */}
              <div className="idea-card__tags">
                {data?.ideaIndustry && (
                  <Tag
                    className="idea-tag industry-tag"
                    key={data?.ideaIndustry?.id}
                    title={data?.ideaIndustry?.label}
                    label={data?.ideaIndustry?.label}
                  />
                )}
                {data?.ideaStage && (
                  <Tag
                    className="idea-tag stage-tag"
                    key={data?.ideaStage?.id}
                    label={data?.ideaStage?.label}
                    title={data?.ideaStage?.label}
                  />
                )}
              </div>
            </div>

            {/* Elevator pitch */}
            {data?.elevatorPitch && (
              <div className="idea-card__description">
                <ReactMarkdown
                  source={
                    data?.elevatorPitch.length < 200
                      ? data?.elevatorPitch.replace(/<br \/>/g, " ")
                      : `${data?.elevatorPitch
                          .replace(/<br \/>/g, " ")
                          .substring(0, 200)
                          .trim()}...`
                  }
                  escapeHtml={false}
                  renderers={customRendererLink}
                />
              </div>
            )}

            {needs && <span className="idea-card__needs">{needs}</span>}

            {/* Bottom row with stats and actions */}
            <div className="idea-card__footer">
              <div className="idea-card__stats">
                <Mutation mutation={UPDATE_IDEAS_LIKES}>
                  {(toggleLikeIdea) => (
                    <button
                      className={`idea-card__action-button ${
                        data?.likes?.find((e) => e?.user?.id === me?.id)?.id
                          ? "liked"
                          : ""
                      }`}
                      onClick={() => {
                        if (me?.id) {
                          toggleLikeIdea({
                            variables: {
                              ideaId: data?.id,
                            },
                          })
                        }
                      }}
                    >
                      <img
                        src={`${
                          data?.likes?.find((e) => e?.user?.id === me?.id)?.id
                            ? "/static/icons/heart-red.svg"
                            : "/static/icons/hard.svg"
                        }`}
                        width={18}
                        height={18}
                        alt="Like"
                      />
                      <span>
                        {data?.totalLikes > 0
                          ? `${data.totalLikes} ${data.totalLikes === 1 ? "like" : "likes"}`
                          : "Like"}
                      </span>
                    </button>
                  )}
                </Mutation>
                {me?.id && (
                  <Mutation mutation={SAVE_IDEA}>
                    {(toggleSaveIdea) => (
                      <button
                        className={`idea-card__action-button save-button ${
                          data?.saves?.find((e) => e?.user?.id === me?.id || e === me?.id)
                            ? "saved"
                            : ""
                        }`}
                        onClick={() =>
                          toggleSaveIdea({
                            variables: {
                              ideaId: data?.id,
                            },
                          })
                        }
                      >
                        <img 
                          src="/static/icons/bookmark.svg" 
                          alt="Save"
                          width={14}
                          height={14}
                        />
                        <span>Save</span>
                      </button>
                    )}
                  </Mutation>
                )}

                {data?.totalComments > 0 && (
                  <div className="idea-card__stat">
                    <img
                      src="/static/icons/message-dark.svg"
                      width={18}
                      height={18}
                      alt=""
                    />
                    <span>
                      {data.totalComments} {data.totalComments === 1 ? "comment" : "comments"}
                    </span>
                  </div>
                )}
              </div>

              <div className="idea-card__actions">
                

                <Link href={`/ideas/${data.id}`}>
                  <a className="idea-card__action-button view-button">
                    <img
                      src="/static/icons/chevron-down.svg"
                      alt="View"
                      width={16}
                      height={16}
                    />
                    View
                  </a>
                </Link>
              </div>
            </div>
          </div>
        </article>
      </ReactCSSTransitionGroup>
    )
  }
}

export default IdeasCards
